import { TERMINAL_GREEN } from '../constants/theme';

function ensureHeadLink(id: string, href: string) {
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

function ensureHeadStyle(id: string, cssText: string) {
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = cssText;
  document.head.appendChild(style);
}

export function injectGlobalStyles() {
  ensureHeadLink(
    'fok-fonts',
    'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;700&display=swap'
  );
  ensureHeadLink(
    'fok-icons',
    'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@100..700,0..1&display=swap'
  );

  ensureHeadStyle(
    'fok-theme-css',
    `
      :root { color-scheme: light; }
      html.dark { color-scheme: dark; }
      body { font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif; -webkit-font-smoothing: antialiased; }
      .mono-text { font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
      .hover-underline:hover { text-decoration: underline; text-underline-offset: 4px; }

      /* Blog prose styling */
      .prose p { margin-bottom: 1.5rem; line-height: 1.8; }
      html.dark .prose p { color: #cbd5e1; }
      .prose h2 { font-weight: 700; font-size: 1.5rem; margin-top: 2.5rem; margin-bottom: 1rem; }
      html.dark .prose h2 { color: #f8fafc; }
      .prose code {
        font-family: "JetBrains Mono", monospace;
        background-color: #1e293b;
        padding: 0.2rem 0.4rem;
        border-radius: 0.125rem;
        font-size: 0.9em;
        color: ${TERMINAL_GREEN};
      }
    `
  );
}
